import React from "react";
import { Input } from "antd";

const InputWrapper = ({ className = "", inputClass = "", ...props }) => {
    return (
        <div
            className={`
                relative flex items-center w-full h-9
                rounded-lg border-2 border-gray-50 bg-gray-50
                focus-within:border-emerald-500
                focus-within:ring-emerald-500/50 focus-within:ring-2 
                transition-all duration-150
                ${className}
            `}
        >
            <Input
                variant="borderless"
                allowClear
                className={`
                    pr-3 text-[13px] sm:text-[14px]
                    placeholder:text-muted-foreground
                    disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50
                    ${inputClass}
                `}
                {...props}
            />
        </div>
    );
};

export default InputWrapper;
